import { render } from "./TodoListCard.vue?vue&type=template&id=48fea973"
import script from "./TodoListCard.vue?vue&type=script&lang=js"
export * from "./TodoListCard.vue?vue&type=script&lang=js"

import "./TodoListCard.vue?vue&type=style&index=0&id=48fea973&lang=scss"

import exportComponent from "/home/runner/work/dotter/dotter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__